
import { useEffect, useState } from "react";
import "./Task.css";

const API_URL = process.env.REACT_APP_API_FAST;

const emptyTaskForm = {
    name: "",
    description: "",
    main_function: "",
    priority: "",
};

const emptyChildForm = {
    function_name: "",
    order_number: "1",
    priority: "medium",
};

const POLLING_INTERVAL = 1000;

export function Tasks() {
    const [tasks, setTasks] = useState([]);
    console.log("task_list_is",tasks)
    const [search, setSearch] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const [form, setForm] = useState(emptyTaskForm);
    const [expandedTaskId, setExpandedTaskId] = useState(null);
    const [childTask, setChildTask] = useState(null);
    console.log("choildTask_is",childTask)
    const [childForm, setChildForm] = useState(emptyChildForm);
    const [childError, setChildError] = useState("");
    const [localChildren, setLocalChildren] = useState({});

    const [panel, setPanel] = useState({
        taskId: null,
        type: null,
    });

    // Live status information returned by FastAPI.
    const [status, setStatus] = useState({});
    const [stage, setStage] = useState({});
    const [threadz, setThread] = useState({});
    const [logs, setLogs] = useState([]);

    // ---------------------------------------------------------
    // LOAD TASKS
    // ---------------------------------------------------------

    async function loadTasks() {
        setLoading(true);
        setError("");

        try {
            const response = await fetch(
                `${API_URL}/task/main_tbl/retrieval`
            );

            if (!response.ok) {
                throw new Error(
                    `Could not load tasks (${response.status}).`
                );
            }

            const data = await response.json();          
            const taskList = Array.isArray(data)
                ? data
                : data.tasks;

            if (!Array.isArray(taskList)) {
                throw new Error(
                    "The API returned an unexpected task list."
                );
            }

            setTasks(taskList);
        } catch (err) {
            setError(
                err.message || "Could not connect to FastAPI."
            );
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadTasks();
    }, []);

    // ---------------------------------------------------------
    // POLL ONE WORKFLOW STATUS
    // ---------------------------------------------------------

    function pollStatus(scriptName) {
        let cancelled = false;
        let polling = false;
        let intervalId = null;

        async function checkStatus() {
            // Prevent overlapping requests for this workflow.
            if (cancelled || polling) {
                return;
            }

            polling = true;

            try {
                const response = await fetch(
                    `${API_URL}/status/${encodeURIComponent(
                        scriptName
                    )}/`
                );

                if (!response.ok) {
                    throw new Error(
                        `Status request failed (${response.status}).`
                    );
                }

                const data = await response.json();
                console.log("daata_test_is ",data)

                if (cancelled) {
                    return;
                }

                console.log(
                    `returns_status [${scriptName}]`,
                    data
                );

                // Save status and optional detail together.
                const statusText = `${
                    data?.status ?? "Unknown"
                }${
                    data?.detail
                        ? ` (${data?.detail})`
                        : ""
                }`;

                setStatus((previous) => ({
                    ...previous,
                    [scriptName]: statusText,
                }));

                // Save the current workflow stage.
                if (data?.stage !== undefined) {
                    setStage((previous) => ({
                        ...previous,
                        [scriptName]: data.stage,
                    }));
                }

                // Update worker and job details.
                if (data?.threads) {
                    const newMap = {};

                    Object.values(data?.threads).forEach(
                        (worker) => {
                            const workerName =
                                worker?.worker_name;

                            if (!workerName) {
                                return;
                            }

                            newMap[workerName] = {
                                state: worker?.state ?? "Unknown",
                                alive: worker?.alive ?? false,
                                error: worker?.error ?? null,
                                thread_name: worker?.thread_name ?? null,
                            };

                           
                        }
                    );

                    setThread((previous) => ({
                        ...previous,
                        ...newMap,
                    }));
                }

                // Record workflow errors without duplicating
                // the same error on every polling cycle.
                if (data?.error) {
                    const message =
                        `Script ${scriptName}: ${data?.error}`;

                    setLogs((previous) => {
                        const alreadyLogged = previous.some(
                            (entry) =>
                                entry.message === message
                        );

                        if (alreadyLogged) {
                            return previous;
                        }

                        return [
                            ...previous,
                            {
                                message,
                                level: "error",
                            },
                        ];
                    });
                }

                // Stop polling when the workflow finishes
                // or requires a manual fix.
                const finalStatus = String(
                    data?.status || ""
                ).toUpperCase();

                if (
                    ["STOPPED", "SUCCESS"].includes(
                        finalStatus
                    ) ||
                    data?.detail === "MANUAL_FIX"
                ) {
                    if (intervalId !== null) {
                        clearInterval(intervalId);
                    }

                    // Only remove the stored script if it
                    // refers to this workflow.
                    if (
                        localStorage.getItem(
                            "runningScript"
                        ) === scriptName
                    ) {
                        localStorage.removeItem(
                            "runningScript"
                        );
                    }
                }
            } catch (err) {
                if (!cancelled) {
                    console.error(
                        `Status poll failed for "${scriptName}":`,
                        err
                    );

                    setStatus((previous) => ({
                        ...previous,
                        [scriptName]:
                            `Unavailable (${err.message})`,
                    }));

                    // Stop this poller on a request failure.
                    if (intervalId !== null) {
                        clearInterval(intervalId);
                    }
                }
            } finally {
                polling = false;
            }
        }

        // Check immediately, then poll every second.
        checkStatus();

        intervalId = setInterval(
            checkStatus,
            POLLING_INTERVAL
        );

        // Return cleanup for this workflow's poller.
        return () => {
            cancelled = true;

            if (intervalId !== null) {
                clearInterval(intervalId);
            }
        };
    }

    // ---------------------------------------------------------
    // POLL ALL LOADED TASKS
    // ---------------------------------------------------------

    useEffect(() => {
        const scriptNames = [
            ...new Set(
                tasks
                    .map((task) => task.name)
                    .filter(Boolean)
            ),
        ];

        if (scriptNames.length === 0) {
            return undefined;
        }

        const cleanups = scriptNames.map(
            (scriptName) => pollStatus(scriptName)
        );

        // Stop all pollers when the task list changes
        // or the component unmounts.
        return () => {
            cleanups.forEach((cleanup) => cleanup());
        };
    }, [tasks]);

    // ---------------------------------------------------------
    // TASK FORM
    // ---------------------------------------------------------

    function updateField(event) {
        const { name, value } = event.target;

        setForm((current) => ({
            ...current,
            [name]: value,
        }));
    }

    function closeForm() {
        if (saving) {
            return;
        }

        setShowForm(false);
        setForm(emptyTaskForm);
    }

    async function handleSubmit(event) {
        event.preventDefault();

        setError("");
        setSuccess("");

        const payload = {
            name: form.name.trim(),
            description: form.description.trim(),
            main_function: form.main_function.trim(),
            priority: form.priority.trim(),
        };

        if (
            !payload.name ||
            !payload.main_function ||
            !payload.priority
        ) {
            setError(
                "Task name, main function, and priority are required."
            );
            return;
        }

        setSaving(true);

        try {
            const response = await fetch(
                `${API_URL}/task/main_tbl/creation`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                const details = await response
                    .json()
                    .catch(() => null);

                throw new Error(
                    details?.detail ||
                    details?.message ||
                    `Could not save task (${response.status}).`
                );
            }

            const createdTask = await response.json();
            const savedTask =
                createdTask?.task || createdTask;

            if (
                savedTask &&
                typeof savedTask === "object" &&
                (
                    savedTask.id != null ||
                    savedTask.task_id != null ||
                    savedTask.name
                )
            ) {
                setTasks((current) => [
                    savedTask,
                    ...current.filter((task) => {
                        const savedId =
                            savedTask.id ??
                            savedTask.task_id;

                        const currentId =
                            task.id ?? task.task_id;

                        if (
                            savedId != null &&
                            currentId != null
                        ) {
                            return currentId !== savedId;
                        }

                        return task.name !== savedTask.name;
                    }),
                ]);
            } else {
                await loadTasks();
            }

            setShowForm(false);
            setForm(emptyTaskForm);
            setSuccess("Task created successfully.");
        } catch (err) {
            setError(
                err.message || "Could not save the task."
            );
        } finally {
            setSaving(false);
        }
    }

    // ---------------------------------------------------------
    // CHILD FUNCTION FORM
    // ---------------------------------------------------------

    function openChildForm(task) {
        setChildTask(task);
        setChildForm(emptyChildForm);
        setChildError("");
    }

async function submitChildForm(event) {
    event.preventDefault();
    setChildError("");
    setError("");
    setSuccess("");

    const parentId = Number(
        childTask.id ?? childTask.task_id
    );

    const functionName = childForm.function_name.trim();
    const orderNumber = Number(childForm.order_number);

    if (!Number.isInteger(parentId) || parentId < 1) {
        setChildError(
            "This task has no valid database ID. Reload the tasks and try again."
        );
        return;
    }

    if (!functionName) {
        setChildError("Child function name is required.");
        return;
    }

    if (!Number.isInteger(orderNumber) || orderNumber < 1) {
        setChildError(
            "Order number must be a whole number greater than zero."
        );
        return;
    }

    const payload = {
        task_id: parentId,
        function_name: functionName,
        order_number: orderNumber,
        priority: childForm.priority,
    };

    try {
        const response = await fetch(
            `${API_URL}/task/children/creation`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            }
        );

        const result = await response.json().catch(() => null);

        if (!response.ok) {
            throw new Error(
                result?.detail ||
                result?.message ||
                `Could not save child (${response.status}).`
            );
        }

        // Use the child's actual ID returned by MySQL.
        const savedChild = result?.child || result;

        // Update the UI after the backend confirms the save.
        setLocalChildren((current) => ({
            ...current,
            [parentId]: [
                ...(current[parentId] || []).filter(
                    (child) =>
                        child.id !== savedChild.id
                ),
                savedChild,
            ].sort(
                (a, b) => a.order_number - b.order_number
            ),
        }));

        setChildTask(null);
        setChildForm(emptyChildForm);
        setSuccess(
            `Child function saved under "${childTask.name}".`
        );
    } catch (err) {
        setChildError(
            err.message || "Could not save the child function."
        );
    }
}

    // ---------------------------------------------------------
    // TASK HELPERS
    // ---------------------------------------------------------

    const filteredTasks = tasks.filter((task) => {
        const searchText = search.toLowerCase();

        return [
            task.name,
            task.description,
            task.main_function,
            task.priority,
        ].some((value) =>
            String(value || "")
                .toLowerCase()
                .includes(searchText)
        );
    });

    function getTaskKey(task, index) {
        return (
            task.id ??
            task.task_id ??
            task.name ??
            index
        );
    }

    function getWorkflowStatus(task) {
        const result = status[task.name];

        if (!result) {
            return {
                label: "Checking...",
                className: "checking",
            };
        }

        if (
            result.startsWith("Unavailable")
        ) {
            return {
                label: result,
                className: "unavailable",
            };
        }

        if (
            result.toLowerCase().startsWith("not_found")
        ) {
            return {
                label: "Not running",
                className: "not-running",
            };
        }

        const statusName =
            result.split(" ")[0].toLowerCase();

        return {
            label: result,
            className: statusName,
        };
    }

    // ---------------------------------------------------------
    // RENDER
    // ---------------------------------------------------------

    return (
        <div className="tasks-page">
            <div className="tasks-page-header">
                <div>
                    <p className="tasks-eyebrow">
                        WORKFLOW MANAGEMENT
                    </p>

                    <h2>Tasks</h2>

                    <p className="tasks-subtitle">
                        Create parent workflows, add child functions,
                        and monitor workflow execution.
                    </p>
                </div>

                <button
                    type="button"
                    className="tasks-create-button"
                    onClick={() => {
                        setError("");
                        setSuccess("");
                        setShowForm(true);
                    }}
                >
                    <span aria-hidden="true">+</span> Create Task
                </button>
            </div>

            {error && (
                <div
                    className="tasks-message tasks-message-error"
                    role="alert"
                >
                    {error}
                </div>
            )}

            {success && (
                <div
                    className="tasks-message tasks-message-success"
                    role="status"
                >
                    {success}
                </div>
            )}

            <div className="tasks-summary">
                <div className="tasks-summary-card">
                    <span>Total tasks</span>
                    <strong>{tasks.length}</strong>
                </div>

                <div className="tasks-summary-card">
                    <span>Enabled</span>
                    <strong>
                        {tasks.filter((task) =>
                            ["enabled", "active"].includes(
                                String(
                                    task.status || ""
                                ).toLowerCase()
                            )
                        ).length}
                    </strong>
                </div>

                <div className="tasks-summary-card">
                    <span>Recently created</span>
                    <strong>
                        {tasks.filter((task) => {
                            if (!task.created_at) {
                                return false;
                            }

                            const daysAgo =
                                (
                                    Date.now() -
                                    new Date(
                                        task.created_at
                                    ).getTime()
                                ) / 86400000;

                            return (
                                daysAgo >= 0 &&
                                daysAgo <= 7
                            );
                        }).length}
                    </strong>
                </div>
            </div>

            <div className="tasks-list-panel">
                <div className="tasks-list-header">
                    <div>
                        <h3>All tasks</h3>
                        <p>
                            Each parent task can contain ordered
                            child functions.
                        </p>
                    </div>

                    <input
                        className="tasks-search"
                        type="search"
                        placeholder="Search tasks..."
                        value={search}
                        onChange={(event) =>
                            setSearch(event.target.value)
                        }
                        aria-label="Search tasks"
                    />
                </div>

                {loading ? (
                    <div className="tasks-empty-state">
                        Loading tasks...
                    </div>
                ) : filteredTasks.length === 0 ? (
                    <div className="tasks-empty-state">
                        <div
                            className="tasks-empty-icon"
                            aria-hidden="true"
                        >
                            ＋
                        </div>

                        <h3>
                            {search
                                ? "No matching tasks"
                                : "No tasks yet"}
                        </h3>

                        <p>
                            {search
                                ? "Try a different search term."
                                : "Create your first task to start organizing your workflows."}
                        </p>

                        {!search && (
                            <button
                                type="button"
                                className="tasks-create-button"
                                onClick={() =>
                                    setShowForm(true)
                                }
                            >
                                + Create your first task
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="tasks-cards">
                        {filteredTasks.map((task, index) => {
                            const taskId = getTaskKey(
                                task,
                                index
                            );

                            const children =
                                localChildren[taskId] || [];

                            const expanded =
                                expandedTaskId === taskId;

                            const activePanel =
                                panel.taskId === taskId
                                    ? panel.type
                                    : null;

                            const workflowStatus =
                                getWorkflowStatus(task);

                            const workflowStage =
                                stage[task.name];

                            const workerDetails =
                                Object.values(threadz).filter(
                                    (worker) =>
                                        Object.keys(worker).length > 0
                                );

                            return (
                                <article
                                    className="task-card"
                                    key={taskId}
                                >
                                    <div className="task-card-main">
                                        <div className="tasks-name-icon">
                                            {String(
                                                task.name || "T"
                                            )
                                                .charAt(0)
                                                .toUpperCase()}
                                        </div>

                                        <div className="task-card-copy">
                                            <h3>
                                                {task.name ||
                                                    "Unnamed task"}
                                            </h3>

                                            <p>
                                                {task.description ||
                                                    "No description provided"}
                                            </p>

                                            <div className="task-function-line">
                                                <span>
                                                    Main function
                                                </span>

                                                <code>
                                                    {task.main_function ||
                                                        task.function_path ||
                                                        "Not set"}
                                                </code>
                                            </div>

                                            <div className="task-card-meta">
                                                <span
                                                    className={`tasks-status tasks-status-${String(
                                                        task.status ||
                                                            "enabled"
                                                    ).toLowerCase()}`}
                                                >
                                                    {task.status ||
                                                        "Enabled"}
                                                </span>

                                                <span>
                                                    {children.length} child
                                                    function
                                                    {children.length === 1
                                                        ? ""
                                                        : "s"}
                                                </span>

                                                <span>
                                                    Created:{" "}
                                                    {task.created_at
                                                        ? new Date(
                                                              task.created_at
                                                          ).toLocaleDateString()
                                                        : "—"}
                                                </span>
                                            </div>

                                            {/* Live workflow status */}
                                            <div className="task-card-meta workflow-status-meta">
                                                <span>
                                                    Workflow:
                                                </span>

                                                <span
                                                    className={`tasks-status tasks-status-${workflowStatus.className}`}
                                                >
                                                    {workflowStatus.label}
                                                </span>

                                                {workflowStage && (
                                                    <span>
                                                        Stage:{" "}
                                                        {workflowStage}
                                                    </span>
                                                )}
                                            </div>

                                            {/* Worker/job status returned by FastAPI */}
                                            {Object.keys(threadz).length > 0 && (
                                                <div className="task-worker-status">
                                                    <strong>
                                                        Worker jobs
                                                    </strong>

                                                    {Object.entries(
                                                        threadz
                                                    ).map(
                                                        ([
                                                            workerName,
                                                            jobs,
                                                        ]) => (
                                                            <div
                                                                key={workerName}
                                                                className="task-worker-group"
                                                            >
                                                                <span>
                                                                    {workerName}
                                                                </span>

                                                                {Object.entries(
                                                                    jobs
                                                                ).map(
                                                                    ([
                                                                        teamCode,
                                                                        job,
                                                                    ]) => (
                                                                        <div
                                                                            key={`${workerName}-${teamCode}`}
                                                                            className="task-worker-job"
                                                                        >
                                                                            <span>
                                                                                {teamCode}:{" "}
                                                                                {job?.status?.state ||
                                                                                    "Unknown"}
                                                                            </span>

                                                                            {job?.status?.duration != null && (
                                                                                <span>
                                                                                    Duration:{" "}
                                                                                    {job?.status?.duration}
                                                                                </span>
                                                                            )}

                                                                            {job?.error && (
                                                                                <span
                                                                                    className="workflow-error"
                                                                                    role="alert"
                                                                                >
                                                                                    Error:{" "}
                                                                                    {job?.error}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    )
                                                                )}
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="task-actions">
                                        <button
                                            type="button"
                                            className="task-action-button task-action-primary"
                                            onClick={() =>
                                                openChildForm(task)
                                            }
                                        >
                                            <span aria-hidden="true">
                                                ＋
                                            </span>{" "}
                                            Add child
                                        </button>

                                        <button
                                            type="button"
                                            className="task-action-button"
                                            aria-expanded={expanded}
                                            onClick={() =>
                                                setExpandedTaskId(
                                                    expanded
                                                        ? null
                                                        : taskId
                                                )
                                            }
                                        >
                                            <span aria-hidden="true">
                                                ☷
                                            </span>{" "}
                                            Children ({children.length})
                                        </button>

                                        <button
                                            type="button"
                                            className={`task-action-button ${
                                                activePanel === "schedule"
                                                    ? "is-selected"
                                                    : ""
                                            }`}
                                            onClick={() =>
                                                setPanel(
                                                    activePanel === "schedule"
                                                        ? {
                                                              taskId: null,
                                                              type: null,
                                                          }
                                                        : {
                                                              taskId,
                                                              type: "schedule",
                                                          }
                                                )
                                            }
                                        >
                                            <span aria-hidden="true">
                                                ◷
                                            </span>{" "}
                                            Schedule
                                        </button>

                                        <button
                                            type="button"
                                            className={`task-action-button ${
                                                activePanel ===
                                                "configuration"
                                                    ? "is-selected"
                                                    : ""
                                            }`}
                                            onClick={() =>
                                                setPanel(
                                                    activePanel ===
                                                    "configuration"
                                                        ? {
                                                              taskId: null,
                                                              type: null,
                                                          }
                                                        : {
                                                              taskId,
                                                              type: "configuration",
                                                          }
                                                )
                                            }
                                        >
                                            <span aria-hidden="true">
                                                ⚙
                                            </span>{" "}
                                            Configuration
                                        </button>
                                    </div>

                                    {expanded && (
                                        <div className="task-detail-panel">
                                            <div className="task-detail-heading">
                                                <div>
                                                    <h4>
                                                        Child functions
                                                    </h4>
                                                    <p>
                                                        Functions are shown
                                                        in execution order.
                                                    </p>
                                                </div>

                                                <button
                                                    type="button"
                                                    className="task-text-button"
                                                    onClick={() =>
                                                        openChildForm(task)
                                                    }
                                                >
                                                    + Add child function
                                                </button>
                                            </div>

                                            {children.length === 0 ? (
                                                <p className="task-detail-empty">
                                                    No child functions added
                                                    in this view yet.
                                                </p>
                                            ) : (
                                                <div className="child-functions-list">
                                                    {children.map(
                                                        (child) => (
                                                            <div
                                                                className="child-function-row"
                                                                key={child.id}
                                                            >
                                                                <span className="child-order">
                                                                    {child.order_number}
                                                                </span>

                                                                <div className="child-function-name">
                                                                    <strong>
                                                                        {child.function_name}
                                                                    </strong>
                                                                    <small>
                                                                        Function
                                                                        name
                                                                    </small>
                                                                </div>

                                                                <span
                                                                    className={`priority-pill priority-${child.priority}`}
                                                                >
                                                                    {child.priority}
                                                                </span>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {activePanel === "schedule" && (
                                        <div className="task-detail-panel">
                                            <h4>Schedule</h4>

                                            <p className="task-panel-description">
                                                Scheduling controls will be
                                                connected to the backend in
                                                a later update.
                                            </p>

                                            <div className="task-placeholder-grid">
                                                <label>
                                                    Frequency
                                                    <select
                                                        defaultValue="manual"
                                                        disabled
                                                    >
                                                        <option value="manual">
                                                            Manual
                                                        </option>
                                                        <option>Hourly</option>
                                                        <option>Daily</option>
                                                        <option>Weekly</option>
                                                    </select>
                                                </label>

                                                <label>
                                                    Start time
                                                    <input
                                                        type="time"
                                                        disabled
                                                    />
                                                </label>

                                                <label>
                                                    Next run
                                                    <input
                                                        type="text"
                                                        placeholder="Not configured"
                                                        disabled
                                                    />
                                                </label>
                                            </div>

                                            <span className="task-coming-soon">
                                                Schedule UI placeholder —
                                                not saved
                                            </span>
                                        </div>
                                    )}

                                    {activePanel === "configuration" && (
                                        <div className="task-detail-panel">
                                            <h4>Configuration</h4>

                                            <p className="task-panel-description">
                                                This area will hold task-level
                                                settings, environment options,
                                                and execution parameters.
                                            </p>

                                            <div className="task-placeholder-grid">
                                                <label>
                                                    Execution mode
                                                    <select
                                                        defaultValue="sequential"
                                                        disabled
                                                    >
                                                        <option value="sequential">
                                                            Sequential
                                                        </option>
                                                        <option>
                                                            Parallel
                                                        </option>
                                                    </select>
                                                </label>

                                                <label>
                                                    Retry limit
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        defaultValue="0"
                                                        disabled
                                                    />
                                                </label>

                                                <label>
                                                    Timeout (seconds)
                                                    <input
                                                        type="number"
                                                        min="1"
                                                        placeholder="Not configured"
                                                        disabled
                                                    />
                                                </label>
                                            </div>

                                            <span className="task-coming-soon">
                                                Configuration UI placeholder —
                                                not saved
                                            </span>
                                        </div>
                                    )}
                                </article>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* WORKFLOW ERROR LOGS */}
            {logs.length > 0 && (
                <div className="tasks-list-panel">
                    <div className="tasks-list-header">
                        <div>
                            <h3>Workflow errors</h3>
                            <p>
                                Errors reported by the status endpoint.
                            </p>
                        </div>

                        <button
                            type="button"
                            className="task-text-button"
                            onClick={() => setLogs([])}
                        >
                            Clear logs
                        </button>
                    </div>

                    <div className="tasks-error-log-list">
                        {logs.map((entry, index) => (
                            <div
                                key={`${entry.message}-${index}`}
                                className="tasks-message tasks-message-error"
                                role="alert"
                            >
                                {entry.message}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* CREATE TASK MODAL */}
            {showForm && (
                <div
                    className="tasks-modal-overlay"
                    onMouseDown={(event) => {
                        if (
                            event.target === event.currentTarget
                        ) {
                            closeForm();
                        }
                    }}
                >
                    <div
                        className="tasks-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="create-task-title"
                    >
                        <div className="tasks-modal-header">
                            <div>
                                <p className="tasks-eyebrow">
                                    NEW WORKFLOW
                                </p>

                                <h2 id="create-task-title">
                                    Create task
                                </h2>

                                <p>
                                    Define the parent task and its
                                    main function.
                                </p>
                            </div>

                            <button
                                type="button"
                                className="tasks-modal-close"
                                onClick={closeForm}
                                disabled={saving}
                                aria-label="Close form"
                            >
                                ×
                            </button>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="tasks-form-body">
                                <div className="tasks-field">
                                    <label htmlFor="task-name">
                                        Task name <span>*</span>
                                    </label>

                                    <input
                                        id="task-name"
                                        name="name"
                                        value={form.name}
                                        onChange={updateField}
                                        placeholder="e.g. Odds Normalization"
                                        maxLength={150}
                                        required
                                    />
                                </div>

                                <div className="tasks-field">
                                    <label htmlFor="task-description">
                                        Description
                                    </label>

                                    <textarea
                                        id="task-description"
                                        name="description"
                                        value={form.description}
                                        onChange={updateField}
                                        placeholder="Describe what this workflow does..."
                                        rows={3}
                                        maxLength={2000}
                                    />
                                </div>

                                <div className="tasks-field">
                                    <label htmlFor="task-main-function">
                                        Main Python function <span>*</span>
                                    </label>

                                    <input
                                        id="task-main-function"
                                        name="main_function"
                                        value={form.main_function}
                                        onChange={updateField}
                                        placeholder="e.g. odds_normalization.main"
                                        maxLength={255}
                                        required
                                    />

                                    <small>
                                        The entry point that orchestrates
                                        the workflow from start to finish.
                                        Child functions are configured
                                        separately.
                                    </small>
                                </div>

                                <div className="tasks-field">
                                    <label htmlFor="task-priority">
                                        Priority <span>*</span>
                                    </label>

                                    <input
                                        id="task-priority"
                                        name="priority"
                                        type="number"
                                        value={form.priority}
                                        onChange={updateField}
                                        placeholder="Number 1-20"
                                        min={0}
                                        max={20}
                                        required
                                    />

                                    <small>
                                        Function execution order.
                                    </small>
                                </div>
                            </div>

                            <div className="tasks-modal-footer">
                                <button
                                    type="button"
                                    className="tasks-cancel-button"
                                    onClick={closeForm}
                                    disabled={saving}
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    className="tasks-create-button"
                                    disabled={saving}
                                >
                                    {saving
                                        ? "Saving..."
                                        : "Save task"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ADD CHILD FUNCTION MODAL */}
            {childTask && (
                <div
                    className="tasks-modal-overlay"
                    onMouseDown={(event) => {
                        if (
                            event.target === event.currentTarget
                        ) {
                            setChildTask(null);
                        }
                    }}
                >
                    <div
                        className="tasks-modal child-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="child-task-title"
                    >
                        <div className="tasks-modal-header">
                            <div>
                                <p className="tasks-eyebrow">
                                    CHILD FUNCTION
                                </p>

                                <h2 id="child-task-title">
                                    Add child function
                                </h2>

                                <p>
                                    Parent task:{" "}
                                    <strong>
                                        {childTask.name ||
                                            "Unnamed task"}
                                    </strong>
                                </p>
                            </div>

                            <button
                                type="button"
                                className="tasks-modal-close"
                                onClick={() =>
                                    setChildTask(null)
                                }
                                aria-label="Close form"
                            >
                                ×
                            </button>
                        </div>

                        {childError && (
                            <div
                                className="tasks-message tasks-message-error child-form-error"
                                role="alert"
                            >
                                {childError}
                            </div>
                        )}

                        <form onSubmit={submitChildForm}>
                            <div className="tasks-form-body">
                                <div className="tasks-field">
                                    <label htmlFor="child-function-name">
                                        Function name <span>*</span>
                                    </label>

                                    <input
                                        id="child-function-name"
                                        value={childForm.function_name}
                                        onChange={(event) =>
                                            setChildForm(
                                                (current) => ({
                                                    ...current,
                                                    function_name:
                                                        event.target.value,
                                                })
                                            )
                                        }
                                        placeholder="e.g. fetch_match_odds"
                                        maxLength={255}
                                        required
                                    />

                                    <small>
                                        Enter the Python function or
                                        callable name for this step.
                                    </small>
                                </div>

                                <div className="child-form-grid">
                                    <div className="tasks-field">
                                        <label htmlFor="child-order-number">
                                            Order number <span>*</span>
                                        </label>

                                        <input
                                            id="child-order-number"
                                            type="number"
                                            min="1"
                                            step="1"
                                            value={childForm.order_number}
                                            onChange={(event) =>
                                                setChildForm(
                                                    (current) => ({
                                                        ...current,
                                                        order_number:
                                                            event.target.value,
                                                    })
                                                )
                                            }
                                            required
                                        />

                                        <small>
                                            Defines when this child runs
                                            in the workflow.
                                        </small>
                                    </div>

                                    <div className="tasks-field">
                                        <label htmlFor="child-priority">
                                            Priority <span>*</span>
                                        </label>

                                        <select
                                            id="child-priority"
                                            value={childForm.priority}
                                            onChange={(event) =>
                                                setChildForm(
                                                    (current) => ({
                                                        ...current,
                                                        priority:
                                                            event.target.value,
                                                    })
                                                )
                                            }
                                        >
                                            <option value="low">
                                                Low
                                            </option>
                                            <option value="medium">
                                                Medium
                                            </option>
                                            <option value="high">
                                                High
                                            </option>
                                            <option value="critical">
                                                Critical
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div className="tasks-info-note">
                                    <strong>Current stage</strong>
                                    <p>
                                        This form currently keeps child
                                        functions in frontend state only.
                                        It does not save them to the
                                        backend or database.
                                    </p>
                                </div>
                            </div>

                            <div className="tasks-modal-footer">
                                <button
                                    type="button"
                                    className="tasks-cancel-button"
                                    onClick={() =>
                                        setChildTask(null)
                                    }
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    className="tasks-create-button"
                                >
                                    Add child function
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
